export const parseErrorMessage = (errorMessage: string) => {
  try {
    const trimmedString = errorMessage.slice(1, -1);
    const unescapedString = trimmedString.replace(/\\"/g, '"');
    const resultObject = JSON.parse(unescapedString);
    return resultObject;
  } catch (error) {
    return errorMessage;
  }
};
